import { render, staticRenderFns } from "./AddCompetenceDialog.vue?vue&type=template&id=60220286"
import script from "./AddCompetenceDialog.vue?vue&type=script&lang=js"
export * from "./AddCompetenceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports